import { columnTypes } from '@/services/Grid/ColumnTypes';

export const jobRemovedPropertyGridColumnTypes = columnTypes;

export const jobRemovedPropertyGridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const jobRemovedPropertyGridColumns = [
  {
    headerName: 'ID',
    field: 'propertyId',
    width: 100,
    minWidth: 100,
    maxWidth: 100,
    filter: 'agSetColumnFilter',
    sort: 'asc',
  },
  {
    headerName: 'UPRN',
    field: 'uprn',
    width: 100,
    minWidth: 100,
    maxWidth: 120,
    filter: 'agSetColumnFilter',
  },
  {
    headerName: 'No Range',
    field: 'numberRange',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Building Name',
    field: 'buildingName',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Unit Number',
    field: 'unitNumber',
    width: 120,
    minWidth: 120,
  },
  {
    headerName: 'Street',
    field: 'street',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Street No',
    field: 'streetNumber',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Postcode',
    field: 'postcode',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Reason For Removal',
    field: 'deletedReason',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Date Removed',
    field: 'deletedDate',
    width: 100,
    minWidth: 100,
    type: 'dateColumn',
  },
  {
    headerName: 'Removed By',
    field: 'deletedBy',
    width: 100,
    minWidth: 100,
  },
];
